import React, { useState } from 'react';
import { Modal, Button, Spinner, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTag, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { assignRole } from '../services/authorizationService';
import RoleCapabilitiesTree from './RoleCapabilitiesTree';


const RoleAssignDrawer = ({ show, onHide, role, userId, onAssigned }) => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleAssign = async () => {
    setSaving(true);
    setError(null);
    try {
      await assignRole({
        userId,
        roleId: role.id,
        // bulk-assign all capabilities with empty scope
        assignments: (role.capabilities || []).map(cap => ({
          capabilityId: cap.id,
          scope: {},
        })),
      });
      onAssigned?.();
      onHide();
    } catch (e) {
      setError(e?.message || 'Failed to assign role');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" className="auth-modal cap-assign-modal" centered>
      <Modal.Header closeButton>
        <div className="cap-assign-header">
          <div className="cap-assign-title-row">
            <div className="cap-assign-icon">
              <FontAwesomeIcon icon={faUserTag} />
            </div>
            <div>
              <div className="cap-assign-name">{role?.name}</div>
              {role?.description && (
                <div className="cap-assign-desc">{role.description}</div>
              )}
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body className="cap-assign-body">
        {error && <div className="cap-assign-error">{error}</div>}

        <div className="cap-no-dims" style={{ marginBottom: '1rem' }}>
          <FontAwesomeIcon icon={faShieldAlt} />
          <p>
            Assigning this role will grant{' '}
            <strong>{role?.capabilities?.length ?? 0} capabilities</strong> in bulk.
          </p>
        </div>

        {/* Reuse the exact same tree you already have */}
        <RoleCapabilitiesTree capabilities={role?.capabilities || []} />
      </Modal.Body>

      <Modal.Footer className="cap-assign-footer">
        <div className="cap-assign-footer-left" />
        <div className="cap-assign-footer-right">
          <Button variant="outline-secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button
            className="auth-btn-primary ms-2"
            onClick={handleAssign}
            disabled={saving}
          >
            {saving && <Spinner size="sm" className="me-2" />}
            Assign Role
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default RoleAssignDrawer;